<template>
  <!-- CONTADOR -->
 
  <!-- COLLAGE -->
  <section ref="collageRef" class="collage-section">
    <div class="collage">
      <div class="photo left" ref="photoLeft">
        <img src="@/assets/IMG_1460.jpg" />
      </div>

      <div class="right-column">
        <div class="photo top" ref="photoTop">
          <img src="@/assets/IMG_1595.jpg" />
        </div>

        <div class="photo bottom" ref="photoBottom">
          <img src="@/assets/IMG_1642.jpg" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

ScrollTrigger.config({
  ignoreMobileResize: true
})

export default {
  name: 'ContadorConCollage',
  setup() {
    const collageRef = ref(null)
    const photoLeft = ref(null)
    const photoTop = ref(null)
    const photoBottom = ref(null)

    const days = ref('00')
    const hours = ref('00')
    const minutes = ref('00')
    const seconds = ref('00')
    let interval

    const updateCountdown = () => {
      const eventDate = new Date('2026-05-02T15:00:00')
      const diff = eventDate - new Date()
      if (diff <= 0) return

      days.value = String(Math.floor(diff / 86400000)).padStart(2, '0')
      hours.value = String(Math.floor(diff / 3600000) % 24).padStart(2, '0')
      minutes.value = String(Math.floor(diff / 60000) % 60).padStart(2, '0')
      seconds.value = String(Math.floor(diff / 1000) % 60).padStart(2, '0')
    }

    onMounted(async () => {
      await nextTick()
      updateCountdown()
      interval = setInterval(updateCountdown, 1000)

      // ESTADO INICIAL
      gsap.set(photoLeft.value, { opacity: 0, x: -140 })
      gsap.set(photoTop.value, { opacity: 0, clipPath: 'inset(0 0 100% 0)' })
      gsap.set(photoBottom.value, { opacity: 0, x: 140 })

      // TIMELINE LIGADO AL SCROLL (PROGRESIVO)
      gsap.timeline({
        scrollTrigger: {
          trigger: collageRef.value,
          start: 'top 90%',
          end: 'top 30%',
          scrub: 0.6,           // 🔥 scroll progresivo real
        },
        defaults: { ease: 'none' }
      })
        .to(photoLeft.value, {
          opacity: 1,
          x: 0,
          duration: 1
        })
        .to(photoTop.value, {
          opacity: 1,
          clipPath: 'inset(0 0 0% 0)',
          duration: 1
        }, '-=0.8')
        .to(photoBottom.value, {
          opacity: 1,
          x: 0,
          duration: 1
        }, '-=0.8')
    })

    onBeforeUnmount(() => {
      clearInterval(interval)
      ScrollTrigger.getAll().forEach(t => t.kill())
    })

    return {
      collageRef,
      photoLeft,
      photoTop,
      photoBottom,
      days,
      hours,
      minutes,
      seconds
    }
  }
}
</script>

<style scoped>
/* ===== CONTADOR ===== */
.countdown-section {
  background-color: rgba(217, 212, 209, 0.95);
  padding: 0 20px 30px;
  text-align: center;
  margin-top: -50px;
}

.faltan {
  font-family: 'cursiva', cursive;
  font-size: 42px;
  margin-top: 40px;
  margin-bottom: 14px;
  color: #000 !important;
}

@media (max-width: 768px) {
  .countdown-section .faltan {
    color: #000 !important;
  }
}

.countdown {
  display: flex;
  justify-content: center;
  gap: 26px;
}

.item span {
  font-family: 'padres', serif;
  font-size: 32px;
  color: #000;
}

.item label {
  font-size: 13px;
  letter-spacing: 1px;
  color: #000;
}

/* ===== COLLAGE ===== */
.collage-section {
  background-color: rgba(217, 212, 209, 0.95);
  padding: 20px 10px 60px;
}

.collage {
  max-width: 390px;
  margin: 0 auto;
  display: flex;
  gap: 10px;
}

.photo.left {
  flex: 1;
  height: 440px;
}

.right-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.right-column .photo {
  height: calc((440px - 10px) / 2);
}

.photo {
  overflow: hidden;
}

.photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
</style>
